var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5C6.067 2.5 4.5 4.067 4.5 6C4.5 7.933 6.067 9.5 8 9.5C9.933 9.5 11.5 7.933 11.5 6C11.5 4.067 9.933 2.5 8 2.5ZM3.5 6C3.5 3.51472 5.51472 1.5 8 1.5C10.4853 1.5 12.5 3.51472 12.5 6C12.5 8.48528 10.4853 10.5 8 10.5C5.51472 10.5 3.5 8.48528 3.5 6Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 10.5C6.85899 10.5 5.73801 10.8004 4.74982 11.371C3.76164 11.9416 2.94107 12.7623 2.37062 13.7505C2.23257 13.9897 1.92678 14.0716 1.68762 13.9336C1.44846 13.7955 1.3665 13.4898 1.50455 13.2506C2.16276 12.1103 3.10957 11.1634 4.24978 10.505C5.39 9.84661 6.68344 9.5 8.00008 9.5C9.31673 9.5 10.6102 9.84661 11.7504 10.505C12.8906 11.1634 13.8374 12.1103 14.4956 13.2506C14.6337 13.4898 14.5517 13.7955 14.3125 13.9336C14.0734 14.0716 13.7676 13.9897 13.6295 13.7505C13.0591 12.7623 12.2385 11.9416 11.2503 11.371C10.2622 10.8004 9.14117 10.5 8.00008 10.5Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3391db1c706c06aeada2bcf0f8354a13.svg";
export { ForwardRef as ReactComponent };